import { styled } from "@creditas/stylitas";

export default styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px;
`;
